
/* injects from baggage-loader */

'use strict';

import AlertController from '../alert/alert.controller';

import { failText } from './quiz-tamandua-c.const';

import { max, filter, findIndex } from 'lodash';

export default class DialogQuizTamanduaCController extends AlertController{
    constructor($log, $rootScope, $timeout, Dialog) {
        'ngInject';
        super($log, $rootScope);
        
        this.$timeout = $timeout;
        this.Dialog = Dialog;

        this.answers = [];
    }

    $onInit(){
        this.answers = this.mountAnswers();
        this.stepsList = [this.getTotalSteps(0), this.getTotalSteps(1)];
    }
    
    validate(){
        let major = max(this.stepsList); 
        let majorPlayerIndex = findIndex(this.resolve.model.players, (p, index) => this.getTotalSteps(index) === major ) + 1;
        
        this.answers[0].error = parseInt(this.answers[0].value) !== this.getTotalSteps(1);
        if(this.stepsList[0] !== this.stepsList[1]){                
            this.answers[1].error = majorPlayerIndex !== parseInt(this.answers[1].value);
        } else{
            this.answers[1].error = false;
        }

        return filter(this.answers, { error: true }).length ? false : true;
    }

    mountAnswers(){        
        let answers = [
            {
                type: 'a1',
                value: null,
                error: false,
                text: "Quantos <b>passos</b> deu o <b>segundo</b> tamanduá?"   
            },
            {
                type: 'a2',
                value: null,
                error: false,
                text: `Qual Tamanduá fez o <b>caminho</b> mais <b>longo</b> ou <b>igual</b>?`
            }
        ]

        return answers;
    }

    onSubmit(form) {
        if (form.$invalid) return;
        return this.validate() ? this.onValidateSuccess() : this.Dialog.showAlert('label-opa', failText);
    }

    onValidateSuccess(){
        //this.Dialog.showFeedback('label-very-good', successText, 'btn-continue', () => {
        this.$timeout(this.ok.bind(this), 200);
        //});
    }    

    getTotalSteps(playerIndex) {
        let player = this.resolve.model.players[playerIndex];
        let total = 0;

        angular.forEach(player.events, attr => {
            total += attr
        });

        return total
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-tamandua-c/quiz-tamandua-c.controller.js